import React, { useContext, useState } from 'react'
import { WordFrequencyStyles } from './Style'
import { Table } from 'components'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getIncorrectWordsFrequencyFetch } from 'store/middlewares/words.crud'
import { initialPage, initialPageSize } from 'keys/pagination'
import { WordReadabilityContext } from './WordReadabilityContext'

const WordFrequency = () => {
    const { dynamicColumns } = useContext(WordReadabilityContext)

    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")

    const wordDefsFrequncy = useQuery({
        queryKey: [qc.incorrectWordsFrequency, page, pageSize, searchVal],
        queryFn: async () => {
            const { data } = await getIncorrectWordsFrequencyFetch({ page, pageSize, sorting, search: searchVal })
            return data
        },
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false
    })

    return (
        <WordFrequencyStyles>
            <div className='table'>
                <Table
                    page={page}
                    setPage={setPage}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    hideSorting
                    loading={!wordDefsFrequncy.data}
                    data={wordDefsFrequncy.data || { results: [] }}
                    columns={dynamicColumns}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                />
            </div>
        </WordFrequencyStyles>
    )
}

export default WordFrequency